module.exports = __webpack_public_path__ + "img/oldmail-02@3x.0393b157.png";